import { Dispatch, Middleware } from 'redux';

import { Capacitor } from '@capacitor/core';
import { AnalyticsService } from '../services/analytics.service';
import { Actions, TypeKeys } from './actions';
import { ApplicationState } from './reducers';

export const analyticsMiddleware: Middleware<{}, ApplicationState, Dispatch<Actions>> = _store => next => (action: Actions) => {

  if (!Capacitor.isNativePlatform()) {
    return next(action);
  }

  switch (action.type) {
    case TypeKeys.AUTH_VERIFY_SUCCESS:
    case TypeKeys.AUTH_SUCCESS: {
      AnalyticsService.instance.setUserId(action.user.userId.toString());
      break;
    }
    case TypeKeys.APP_LOAD_SUCCESS: {
      AnalyticsService.instance.setAppId(action.app.id.toString());
      break;
    }
  }
  return next(action);
}
